import { mapEnumToOptions } from '@abp/ng.core';

export enum LeadRequestType {
  Sommelier = 0,
  Client = 1,
  PickupPoint = 2,
  Company = 3,
}

export const leadRequestTypeOptions = mapEnumToOptions(LeadRequestType);
